import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Force light mode permanently
document.documentElement.classList.add("light");
document.documentElement.classList.remove("dark");

// Defer service worker registration
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    setTimeout(() => {
      import('virtual:pwa-register').then(({ registerSW }) => {
        registerSW({ immediate: false });
      }).catch(() => {});
    }, 3000);
  });
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

